import { COLOR_OPTIONS } from 'config/style';
import { StressRiskLevel } from '../../abiotic-stress/domain/abiotic-stress.models';

export const getStressBackgroundColor = (stressRiskLevel: StressRiskLevel): string => {
  switch (stressRiskLevel) {
    case StressRiskLevel.COLD_LOW:
      return COLOR_OPTIONS.BLUE_20;
    case StressRiskLevel.COLD_MEDIUM:
      return COLOR_OPTIONS.BLUE_40;
    case StressRiskLevel.COLD_HIGH:
      return COLOR_OPTIONS.BLUE_70;
    case StressRiskLevel.HEAT_LOW:
      return COLOR_OPTIONS.RED_20;
    case StressRiskLevel.HEAT_MEDIUM:
      return COLOR_OPTIONS.RED_40;
    case StressRiskLevel.HEAT_HIGH:
      return COLOR_OPTIONS.RED_70;
    case StressRiskLevel.NONE:
    default:
      return COLOR_OPTIONS.NEUTRAL_30;
  }
};

export const getStressTextColor = (stressRiskLevel: StressRiskLevel): string => {
  switch (stressRiskLevel) {
    case StressRiskLevel.COLD_LOW:
    case StressRiskLevel.COLD_MEDIUM:
    case StressRiskLevel.HEAT_LOW:
    case StressRiskLevel.HEAT_MEDIUM:
      return COLOR_OPTIONS.NEUTRAL_100;
    case StressRiskLevel.COLD_HIGH:
    case StressRiskLevel.HEAT_HIGH:
      return COLOR_OPTIONS.NEUTRAL_00;
    case StressRiskLevel.NONE:
    default:
      return COLOR_OPTIONS.NEUTRAL_80;
  }
};

export const getStressLabel = (stressRiskLevel: StressRiskLevel): string => {
  switch (stressRiskLevel) {
    case StressRiskLevel.COLD_LOW:
    case StressRiskLevel.HEAT_LOW:
      return 'pages.disease_risk.low';
    case StressRiskLevel.COLD_MEDIUM:
    case StressRiskLevel.HEAT_MEDIUM:
      return 'pages.disease_risk.medium';
    case StressRiskLevel.COLD_HIGH:
    case StressRiskLevel.HEAT_HIGH:
      return 'pages.disease_risk.high';
    case StressRiskLevel.NONE:
    default:
      return 'pages.disease_risk.information_message.not_applicable';
  }
};

export const isValidStressRiskLevel = (stressRiskLevel: StressRiskLevel | undefined | null): stressRiskLevel is StressRiskLevel => {
  if (stressRiskLevel === undefined || stressRiskLevel === null) return false;
  return Object.values(StressRiskLevel).includes(stressRiskLevel);
};
